import React from 'react';
import { createRoot } from 'react-dom/client';

/*
 * The design-derived stylesheet is imported from app/public rather than
 * copied into this project. It is 55KB transcribed from the Claude Design
 * export -- colour tokens, the §1.4 band-contrast rules, sticky headers,
 * focus-visible treatments -- and two copies would drift the moment either
 * frontend was touched. One file, both frontends.
 */
import '../../public/styles.css';
// After the shared sheet: it only restores the full-height flex contract that
// #root interrupts. See the file for why it is not in styles.css.
import './react-shell.css';

import App from './App.jsx';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
